// GroupOfExpertise.tsx
import React from "react";

type Subject = {
  id: string;
  subject: string;
  category: "High School" | "Middle School 6-8" | "Elementary K-5";
  createdAt: string;
  updatedAt: string;
};

type GroupOfExpertiseProps = {
  areaOfExpertise: Subject[];
};

const GroupOfExpertise: React.FC<GroupOfExpertiseProps> = ({
  areaOfExpertise,
}) => {
  const groupedByCategory = areaOfExpertise.reduce((acc, item) => {
    if (!acc[item.category]) {
      acc[item.category] = [];
    }
    acc[item.category].push(item);
    return acc;
  }, {} as Record<string, Subject[]>);

  const categoryOrder: Subject["category"][] = [
    "High School",
    "Middle School 6-8",
    "Elementary K-5",
  ];

  return (
    <div>
      {categoryOrder.map((category) => {
        const subjects = groupedByCategory[category];
        if (!subjects) return null;

        return (
          <div key={category} className="mb-4">
            <h3 className="font-semibold text-lg">{category}</h3>
            <ul className="list-disc list-inside pl-4">
              {subjects.map((subject) => (
                <li key={subject.id}>{subject.subject}</li>
              ))}
            </ul>
          </div>
        );
      })}
    </div>
  );
};

export default GroupOfExpertise;
